<template>
<v-layout column class="px-2">
  <v-flex>
    <v-text-field
      v-model="searchTerm"
      class="search-field mb-1"
      append-icon="search"
      label="Search"
      solo
      clearable
      hide-details
      @click:clear="onClearClicked"
      @change="performSearch"
    />

    <v-card
      v-if="showResults"
      class="extend-right-past-filter-button"
    >
      <v-data-iterator
        :items="searchResults"
        content-tag="v-list"
        no-data-text="No results found"
        two-line
      >
        <template v-slot:item="props">
          <v-list-tile
            avatar
            @click="$router.push({name: 'stroll', params: {strollId: props.item.id}})"
          >
            <stroll-avatar :stroll="props.item" />
            <v-list-tile-content>
              <v-list-tile-title v-text="props.item.title" />
              <v-list-tile-sub-title>
                {{ props.item.description_text }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <div slot="footer">
          <v-divider />
        </div>
      </v-data-iterator>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import { mapActions } from 'vuex'
import StrollAvatar from '@/components/StrollAvatar.vue'

export default {
  name: 'Search',

  components: {
    StrollAvatar,
  },

  data() {
    return {
      searchResults: [],
      searchTerm: '',
      showResults: false,
    }
  },

  methods: {
    ...mapActions(['searchStrolls']),

    onClearClicked() {
      this.showResults = false
    },

    async performSearch() {
      const searchTerm = this.searchTerm
      if (!searchTerm) {
        return
      }
      const results = await this.searchStrolls({searchTerm})
      this.searchResults = results
      this.showResults = true
    }
  }

}
</script>

<style lang="sass">
.extend-right-past-filter-button
  margin-right: -96px
</style>
